import React from 'react';

interface SessionExpiryPromptProps {
  remainingTime: number | null;
  onRefresh: () => void;
  onDismiss: () => void;
}

const SessionExpiryPrompt: React.FC<SessionExpiryPromptProps> = ({
  remainingTime,
  onRefresh,
  onDismiss,
}) => {
  const styles = {
    modalOverlay: {
      position: 'fixed' as 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      textAlign: 'center' as 'center',
      zIndex: 1001,
    },
    modalActions: {
      marginTop: '20px',
    },
    button: {
      margin: '0 10px',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    refreshButton: {
      background: '#4caf50',
      color: 'white',
    },
    dismissButton: {
      background: '#f44336',
      color: 'white',
    },
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modal}>
        <h4>Η συνεδρία λήγει σύντομα</h4>
        <p>
         Η συνεδρία λήγει{' '}
          {remainingTime !== null ? Math.ceil(remainingTime / 1000) : '--'} δευτερόλεπτα.
        </p>
        <div style={styles.modalActions}>
          <button
            style={{ ...styles.button, ...styles.refreshButton }}
            onClick={onRefresh}
          >
           Ανανέωση
          </button>
          {/*<button
            style={{ ...styles.button, ...styles.dismissButton }}
            onClick={onDismiss}
          >
            Dismiss
          </button>*/}
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryPrompt;
